<div class="timer-container" data-name="Timer" data-node-id="3157-4608">
  <div class="time-display" data-node-id="3157-4609">
    <p class="time-text">
      {{ timeDisplay() }}
    </p>
  </div>
  
  <!-- Webm animation - shows when timer increases -->
  <video 
    class="timer-animation-video" 
    [class.show]="animationTrigger() > 0"
    [src]="'assets/clock.webm'"
    autoplay
    muted
    loop="false">
  </video>
</div>
